import type { MonthPrice, PublicBootstrap } from "./types";

export const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const DEFAULT_PRICES: MonthPrice[] = [
  350, 350, 375, 425, 475, 575, 700, 700, 575, 450, 350, 400,
].map((nightlyRate, index) => ({
  month: index + 1,
  nightlyRate,
  minimumNights: index >= 5 && index <= 8 ? 7 : 4,
}));

export const FALLBACK_BOOTSTRAP: PublicBootstrap = {
  currency: "EUR",
  prices: DEFAULT_PRICES,
  unavailable: [],
};

export const FEATURED_PHOTOS = [
  { src: "/images/villa/SP0002.jpg", alt: "Turquoise pool overlooking the Mediterranean" },
  { src: "/images/villa/SP0001.jpg", alt: "White villa and private swimming pool" },
  { src: "/images/villa/SP0011.jpg", alt: "Living room opening onto the terrace" },
  { src: "/images/villa/SP0003.jpg", alt: "Pool terrace in the Javea sunshine" },
  { src: "/images/villa/SP0030.jpg", alt: "Dining table looking out over the sea" },
  { src: "/images/villa/SP0052.jpg", alt: "Calm bedroom with doors to the terrace" },
  { src: "/images/villa/SP0031.jpg", alt: "Dining table looking out over the sea" },
  { src: "/images/villa/SP0038.jpg", alt: "Warm oak and white Mediterranean kitchen" },
];

const galleryFiles = Array.from(new Set([
  ...FEATURED_PHOTOS.map((photo) => photo.src.split("/").at(-1) || ""),
  ...Array.from({ length: 52 }, (_, index) => `SP${String(index + 1).padStart(4, "0")}.jpg`),
  "DJI_20260709144032_0572_D.jpg",
  "DJI_20260709144039_0573_D.jpg",
  "DJI_20260709144047_0574_D.jpg",
  "DJI_20260709144100_0575_D.jpg",
  "DJI_20260709144107_0576_D.jpg",
  "DJI_20260709144122_0577_D.jpg",
  "DJI_20260709144158_0578_D.jpg",
  "DJI_20260709144234_0579_D.jpg",
]));

export const ALL_PHOTOS = galleryFiles.map((file, index) => ({
  src: `/images/villa/${file}`,
  alt: index < 6 ? "Villa Paganini in Javea" : "Inside Villa Paganini",
}));

export const EXPERIENCES = [
  {
    number: "01",
    title: "The coves",
    text: "Granadella and Portitxol both have clear water and small pebble beaches. Go early in summer, before they get busy.",
    meta: "Swimming",
  },
  {
    number: "02",
    title: "Lunch by the port",
    text: "There are plenty of good restaurants around the port. Seafood and arroz are the obvious choices.",
    meta: "Food",
  },
  {
    number: "03",
    title: "The Montgó",
    text: "Walk to the summit for the views, or take the easier route past the old windmills above town.",
    meta: "Walking",
  },
  {
    number: "04",
    title: "The old town",
    text: "A good place for a morning wander, with narrow streets, the covered market and several decent cafés.",
    meta: "Morning",
  },
];
